<template>
  <div class="upload-view">
    <h2>Subir archivo .tar.gz</h2>

    <input type="file" @change="handleFileChange" class="form-control mb-2" />
    <button class="btn btn-primary" @click="uploadFile" :disabled="!file">Subir</button>

    <p v-if="message" class="mt-3">{{ message }}</p>
  </div>
</template>

<script>
export default {
  name: 'LegacyUploadView',

  data() {
    return {
      file: null,
      message: '',
      url: process.env.DASHBOARD_BACKEND_URL
        ? process.env.DASHBOARD_BACKEND_URL + '/api/v1/file-manager/targz/legacy-upload'
        : null,
    };
  },

  methods: {
    handleFileChange(event) {
      this.file = event.target.files[0];
      this.message = '';
    },

    async uploadFile() {
      if (!this.file) {
        alert('Por favor, seleccioná un archivo.');
        return;
      }

      const token = localStorage.getItem('token');

      if (!token) {
        alert('No se encontró token de autenticación.');
        return;
      }

      const formData = new FormData();
      formData.append('file', this.file);

      try {
        const response = await fetch(this.url, {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: formData,
        });

        if (!response.ok) {
          const contentType = response.headers.get('content-type');
          const error = contentType?.includes('application/json')
            ? await response.json()
            : await response.text();
          throw new Error(error.message || error || 'Error al subir');
        }

        const data = await response.json();
        this.message = data.message;
      } catch (error) {
        this.message = '❌ Error al subir el archivo.';
      }
    },
  },
};
</script>

<style scoped>
.upload-view {
  max-width: 500px;
  margin: 2rem auto;
  text-align: center;
}
</style>
